import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum VISIT_TABS_INDEX {
    ALL = 0,
    REJECTED = 1,
    PENDING = 2,
    PROGRAMMED = 3,
    IN_PROGRESS = 4,
    IN_REVISION = 5,
    CLOSED = 6
}

interface VisitsInitialState {
    currentTab: number;
}

const initialState: VisitsInitialState = {
    currentTab: VISIT_TABS_INDEX.PENDING
};

const visitsSlice = createSlice({
    name: 'visits',
    initialState,
    reducers: {
        setCurrentTab: (state, action: PayloadAction<number | null>) => {
            state.currentTab = action.payload ?? VISIT_TABS_INDEX.PENDING;
        }
    }
});

export const { setCurrentTab } = visitsSlice.actions;
export default visitsSlice.reducer;
